const { NODE_ENV } = process.env;

export const getUrl = () => {
//  if (NODE_ENV === "production") {
    return "http://api.passagevan.codapps.com.br";
//    // return "http://157.245.84.239:9044";
//  }

//  return "http://localhost:9044";
};
